<div class="d-flex flex-column vh-100">
  <div style="overflow:hidden;" class="row flex-grow-1">
    <div *ngFor="let img of gridImages" class="col-1 nopadding">
      <div class="d-flex h-100">
        <div class="mx-auto my-auto">
          <img src="assets/sources/{{img}}" class="rounded img-fluid" style="opacity: 0.2;">
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-center align-items-center position-absolute w-100 h-100" style="z-index: 13;">
    <div class="az-card-signin">
      <div>
        <h4>Welcome to Fasten</h4>

        <div *ngIf="error" class="alert alert-danger">{{ error }}</div>

        <div *ngIf="loading" class="d-flex align-items-center text-muted">
            <span class="spinner-border spinner-border-sm"></span>
            Fetching your secure encryption key...
        </div>

        <div *ngIf="encryptionKey && !loading">
            <p class="text-muted">
                This encryption key has been generated for you automatically and will only be shown once.
                Please save it securely by downloading it before continuing.
            </p>

            <label for="encryptionKey" class="form-label font-weight-bold">Your Encryption Key</label>
            <div class="d-flex align-items-center mb-3">
                <input [type]="showEncryptionKey ? 'text' : 'password'" class="form-control font-monospace" id="encryptionKey"
                    [value]="encryptionKey" readonly />
                <button class="btn btn-outline-secondary" type="button" (click)="toggleEncryptionKeyVisibility()">
                    {{ showEncryptionKey ? 'Hide' : 'Show' }}
                </button>
            </div>

            <div class="mb-3 form-check">
                <input type="checkbox" class="form-check-input" id="acknowledge" [(ngModel)]="acknowledged"
                    name="acknowledge" />
                <label class="form-check-label" for="acknowledge">
                    I understand that I will no longer have access to this encryption key once I leave this page.
                </label>
            </div>

            <div class="mt-3 d-flex">
                <button class="btn btn-outline-secondary mr-2" (click)="copyToClipboard()">
                    <fa-icon [icon]="['fas', 'copy']"></fa-icon> Copy
                </button>
                <button class="btn btn-outline-success" (click)="downloadEncryptionKey()" [disabled]="encryptionKeyDownloaded">
                    <fa-icon [icon]="['fas', 'download']"></fa-icon> Download as .txt
                </button>
            </div>

            <div class="alert alert-warning mt-3">
                <strong>Important:</strong> You must download this encryption key before continuing. It will not be shown again.
            </div>

            <div class="mt-4 text-right">
                <button class="btn btn-primary" [disabled]="!acknowledged || !encryptionKeyDownloaded || settingUpKey" (click)="proceedToSignup()">
                    <span *ngIf="settingUpKey" class="spinner-border spinner-border-sm mr-2"></span>
                    <ng-container *ngIf="!settingUpKey">Continue to Sign Up →</ng-container>
                    <ng-container *ngIf="settingUpKey">Setting up key... ({{ countdown }}s)</ng-container>
                </button>
            </div>
        </div>
      </div>
    </div>
  </div>
</div>
